document.addEventListener('DOMContentLoaded', function () {
  // Use event delegation to handle clicks on all BSS product labels
  document.addEventListener('click', function (e) {
    // Check if the clicked element is a BSS product label or its child
    const bssLabel = e.target.closest('.bss_pl_img, .bss-pl-frontend, .bss_pl_label_text');

    if (bssLabel) {
      // Find the closest product card container
      const productCard = bssLabel.closest('.goshop-product-card-wrapper');

      if (productCard) {
        // Look for the product URL in data attribute or link
        const overlayContainer = productCard.querySelector('.goshop-overlay-container[data-product-url]');
        const productLink = productCard.querySelector('a[href*="/products/"]');

        let productUrl = null;

        if (overlayContainer && overlayContainer.dataset.productUrl) {
          productUrl = overlayContainer.dataset.productUrl;
        } else if (productLink) {
          productUrl = productLink.href;
        }

        if (productUrl) {
          e.preventDefault(); // Prevent any default behavior
          e.stopPropagation(); // Stop event bubbling
          window.location.href = productUrl;
        }
      }
    }
  });
});
